import { render, staticRenderFns } from "./SuitableConvertersTab.vue?vue&type=template&id=52151c54&"
import script from "./SuitableConvertersTab.vue?vue&type=script&lang=js&"
export * from "./SuitableConvertersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports